"use strict";

angular.module("customer")
.component("informationConfirmation", {
    templateUrl: require("./information-confirmation.component.html"),
    controller: function($scope, $rootScope, $state, UserService) {
        var _this = this;
        this.displayWarning = false;

        function refreshDisplay(user) {
            if (user) {
                _this.displayWarning = (
                    !user.have_to_agree_tos && user.has_profile_completed
                    && user.has_profile_completed.all && user.has_to_confirm_information
                );
                _this.firstName = user.first_name;
                _this.email = user.email;
            }
        }

        UserService.isUserFetched().then(function onSuccess(user) {
            refreshDisplay(user);
        });

        $scope.$on("UserUpdated", function(event, user) {
            refreshDisplay(user);
        });

        $scope.$on("UserWithoutCustomerUpdated", function(event, user) {
            refreshDisplay(user);
        });

        $scope.$on("UserLoggedOut", function() {
            _this.displayWarning = false;
        });

        this.goToProfileEdition = function() {
            UserService.setModified().then(function() {
                $state.go("profile-edit");
            });

        };

        this.confirmInformation = function() {
            UserService.setModified();
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/information-confirmation/information-confirmation.component.js
// module id = 833
// module chunks = 0